// BookingBoard.js - Modern Table Booking Screen
import {
  AlertCircle,
  Calendar,
  CheckCircle2,
  Clock,
  Mail,
  MapPin,
  Minus,
  Phone,
  Plus,
  Search,
  Trash2,
  User,
  Users,
  X
} from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useScreenLogging } from '../../../hooks/useScreenLogging';
import loggingService from '../../../services/loggingService';
import { getAllSites } from '../../SiteManagement/siteApi';
import { SuccessOverlay } from '../../ui';
import Button from '../../ui/button';
import Card from '../../ui/card';
import { tableBookingApi } from '../tableBookingApi';

// Dummy data - COMMENTED OUT: Now using API calls
// const dummySites = [
//   { site_id: '1', site_name: 'Downtown Restaurant' },
//   { site_id: '2', site_name: 'Mall Location' },
//   { site_id: '3', site_name: 'Airport Branch' },
//   { site_id: '4', site_name: 'Beachside Cafe' },
//   { site_id: '5', site_name: 'City Center' },
// ];

// const dummyFloorPlans = {
//   '1': [
//     { floorplan_id: '1-1', site_id: '1', floor_name: 'Ground Floor', block_section: 'Main Dining', is_active: true },
//     { floorplan_id: '1-2', site_id: '1', floor_name: 'Ground Floor', block_section: 'Outdoor Patio', is_active: false },
//     { floorplan_id: '1-3', site_id: '1', floor_name: 'Second Floor', block_section: 'Private Dining', is_active: false },
//   ],
//   '2': [
//     { floorplan_id: '2-1', site_id: '2', floor_name: 'Level 1', block_section: 'Food Court', is_active: true },
//     { floorplan_id: '2-2', site_id: '2', floor_name: 'Level 1', block_section: 'Casual Dining', is_active: false },
//   ],
//   '3': [
//     { floorplan_id: '3-1', site_id: '3', floor_name: 'Terminal A', block_section: 'Gate 1-10', is_active: true },
//   ],
//   '4': [
//     { floorplan_id: '4-1', site_id: '4', floor_name: 'Beachfront', block_section: 'Outdoor Seating', is_active: true },
//   ],
//   '5': [
//     { floorplan_id: '5-1', site_id: '5', floor_name: 'First Floor', block_section: 'Lobby', is_active: true },
//   ],
// };

// const dummyTables = {
//   '1-1': [
//     { table_id: 't1-1-01', table_number: '01', capacity: 2, position: { x: 50, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't1-1-02', table_number: '02', capacity: 4, position: { x: 200, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't1-1-03', table_number: '03', capacity: 2, position: { x: 350, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't1-1-04', table_number: '04', capacity: 6, position: { x: 50, y: 200 }, size: { width: 120, height: 120 }, shape: 'rectangle' },
//     { table_id: 't1-1-05', table_number: '05', capacity: 4, position: { x: 200, y: 200 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't1-1-06', table_number: '06', capacity: 2, position: { x: 350, y: 200 }, size: { width: 80, height: 80 }, shape: 'circle' },
//   ],
//   '1-2': [
//     { table_id: 't1-2-01', table_number: '01', capacity: 4, position: { x: 50, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't1-2-02', table_number: '02', capacity: 4, position: { x: 200, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't1-2-03', table_number: '03', capacity: 6, position: { x: 350, y: 50 }, size: { width: 120, height: 120 }, shape: 'rectangle' },
//     { table_id: 't1-2-04', table_number: '04', capacity: 8, position: { x: 50, y: 200 }, size: { width: 140, height: 140 }, shape: 'rectangle' },
//   ],
//   '2-1': [
//     { table_id: 't2-1-01', table_number: '01', capacity: 2, position: { x: 50, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't2-1-02', table_number: '02', capacity: 2, position: { x: 200, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't2-1-03', table_number: '03', capacity: 4, position: { x: 350, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't2-1-04', table_number: '04', capacity: 4, position: { x: 50, y: 200 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't2-1-05', table_number: '05', capacity: 2, position: { x: 200, y: 200 }, size: { width: 80, height: 80 }, shape: 'circle' },
//   ],
//   '3-1': [
//     { table_id: 't3-1-01', table_number: '01', capacity: 2, position: { x: 50, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't3-1-02', table_number: '02', capacity: 2, position: { x: 200, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't3-1-03', table_number: '03', capacity: 4, position: { x: 350, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't3-1-04', table_number: '04', capacity: 2, position: { x: 50, y: 200 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't3-1-05', table_number: '05', capacity: 4, position: { x: 200, y: 200 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//   ],
//   '4-1': [
//     { table_id: 't4-1-01', table_number: '01', capacity: 4, position: { x: 50, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't4-1-02', table_number: '02', capacity: 6, position: { x: 200, y: 50 }, size: { width: 120, height: 120 }, shape: 'rectangle' },
//     { table_id: 't4-1-03', table_number: '03', capacity: 4, position: { x: 350, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't4-1-04', table_number: '04', capacity: 8, position: { x: 50, y: 200 }, size: { width: 140, height: 140 }, shape: 'rectangle' },
//   ],
//   '5-1': [
//     { table_id: 't5-1-01', table_number: '01', capacity: 2, position: { x: 50, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't5-1-02', table_number: '02', capacity: 4, position: { x: 200, y: 50 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//     { table_id: 't5-1-03', table_number: '03', capacity: 2, position: { x: 350, y: 50 }, size: { width: 80, height: 80 }, shape: 'circle' },
//     { table_id: 't5-1-04', table_number: '04', capacity: 4, position: { x: 50, y: 200 }, size: { width: 100, height: 100 }, shape: 'rectangle' },
//   ],
// };

// Generate dummy bookings - COMMENTED OUT: Now using API calls
// const generateDummyBookings = (siteId, date) => {
//   const bookings = [];
//   const today = new Date().toISOString().split('T')[0];
//   const isToday = date === today;
//   
//   const siteFloorPlans = dummyFloorPlans[siteId] || [];
//   const allTableIds = [];
//   siteFloorPlans.forEach(fp => {
//     const tables = dummyTables[fp.floorplan_id] || [];
//     tables.forEach(t => allTableIds.push({ table_id: t.table_id, floorplan_id: fp.floorplan_id }));
//   });

//   if (allTableIds.length === 0) return [];

//   const timeSlots = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '18:00', '19:00', '20:00', '21:00'];
//   const statuses = ['reserved', 'seated', 'check_requested'];
//   const guestNames = ['John Smith', 'Sarah Johnson', 'Michael Brown', 'Emily Davis', 'David Wilson', 'Lisa Anderson', 'Robert Taylor', 'Jennifer Martinez'];
//   const guestPhones = ['+1-555-0101', '+1-555-0102', '+1-555-0103', '+1-555-0104', '+1-555-0105', '+1-555-0106', '+1-555-0107', '+1-555-0108'];
//   const guestEmails = ['john@example.com', 'sarah@example.com', 'michael@example.com', 'emily@example.com', 'david@example.com', 'lisa@example.com', 'robert@example.com', 'jennifer@example.com'];

//   timeSlots.forEach((time, idx) => {
//     const numBookings = Math.floor(Math.random() * 3) + 2;
//     for (let i = 0; i < numBookings && i < allTableIds.length; i++) {
//       const tableInfo = allTableIds[(idx * numBookings + i) % allTableIds.length];
//       const bookingTime = `${date}T${time}:00`;
//       const slotEnd = new Date(new Date(bookingTime).getTime() + 2 * 60 * 60 * 1000);
//       
//       bookings.push({
//         booking_id: `b${siteId}-${idx}-${i}`,
//         table_id: tableInfo.table_id,
//         guest_name: guestNames[(idx * numBookings + i) % guestNames.length],
//         guest_phone: guestPhones[(idx * numBookings + i) % guestPhones.length],
//         guest_email: guestEmails[(idx * numBookings + i) % guestEmails.length],
//         party_size: Math.floor(Math.random() * 6) + 2,
//         booking_time: bookingTime,
//         slot_start: bookingTime,
//         slot_end: slotEnd.toISOString(),
//         status: isToday && idx < 3 ? statuses[Math.floor(Math.random() * statuses.length)] : 'reserved',
//         site_id: siteId,
//         special_requests: idx % 3 === 0 ? 'Window seat preferred' : '',
//       });
//     }
//   });

//   return bookings;
// };

const BookingBoard = () => {
  // Log screen view
  useScreenLogging('BookingBoard', {
    component: 'BookingBoard',
    screenType: 'booking-board',
  });

  const [sites, setSites] = useState([]);
  const [selectedSiteId, setSelectedSiteId] = useState('');
  const [floorPlans, setFloorPlans] = useState([]);
  const [selectedFloorPlan, setSelectedFloorPlan] = useState(null);
  const [allTables, setAllTables] = useState([]); // Store all tables from API
  const [tables, setTables] = useState([]); // Filtered tables to display
  const [bookings, setBookings] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  // Filters
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedTime, setSelectedTime] = useState('');
  const [partySize, setPartySize] = useState('');
  const [filterStartTime, setFilterStartTime] = useState(() => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  });
  const [filterEndTime, setFilterEndTime] = useState(() => {
    const end = new Date(Date.now() + 60 * 60 * 1000);
    return `${String(end.getHours()).padStart(2, '0')}:${String(end.getMinutes()).padStart(2, '0')}`;
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFloorNo, setSelectedFloorNo] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  
  // Booking form
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [editingBookingId, setEditingBookingId] = useState(null);
  const [bookingForm, setBookingForm] = useState({
    guest_name: '',
    guest_phone: '',
    guest_email: '',
    party_size: '',
    booking_date: new Date().toISOString().split('T')[0],
    booking_time: '',
    start_time: '',
    end_time: '',
    table_id: '',
    table_no: '',
    special_requests: '',
  });

  // Grid editor state
  const [grid, setGrid] = useState([]);
  const [gridRows, setGridRows] = useState(3);
  const [gridColumns, setGridColumns] = useState(3);
  const [zoom, setZoom] = useState(100);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const gridContainerRef = useRef(null);
  const gridParentRef = useRef(null);
  const dragStartRef = useRef({ x: 0, y: 0 });

  // Panel style
  const panelStyle = {
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), linear-gradient(170deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.40) 97.94%)',
    boxShadow: '0px 5px 20.1px 0px rgba(255, 255, 255, 0.10), 0px 15px 30px 0px rgba(0, 0, 0, 0.10), 0px 4px 25px 0px rgba(255, 255, 255, 0.35) inset',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    backdropFilter: 'blur(30px)',
  };

  // Generate time slots
  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 9; hour <= 22; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const timeStr = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
        slots.push(timeStr);
      }
    }
    return slots;
  };

  const timeSlots = generateTimeSlots();

  // Load sites on mount
  useEffect(() => {
    loadSites();
  }, []);

  // Load tables when site changes
  useEffect(() => {
    if (selectedSiteId) {
      loadAllTables();
      // Reset filters when site changes
      setSelectedFloorNo('');
      setSelectedSection('');
    }
  }, [selectedSiteId]);

  // Auto-select first section when floor_no is selected
  useEffect(() => {
    if (selectedFloorNo && !selectedSection && allTables.length > 0) {
      const filtered = allTables.filter(table => 
        table.floor_no !== null && 
        table.floor_no !== undefined && 
        table.floor_no.toString() === selectedFloorNo
      );
      const uniqueSections = [...new Set(filtered.map(t => t.section).filter(s => s))];
      if (uniqueSections.length > 0) {
        setSelectedSection(uniqueSections[0]);
      }
    }
  }, [selectedFloorNo, allTables]);

  // When selected table changes in booking form, clamp party size to table capacity
  useEffect(() => {
    if (!showBookingForm || !selectedTable) return;
    const cap = Number(selectedTable.capacity) || 0;
    if (cap <= 0) return;
    const current = bookingForm.party_size ? parseInt(bookingForm.party_size, 10) : 0;
    if (!isNaN(current) && current > cap) {
      setBookingForm(prev => ({ ...prev, party_size: String(cap) }));
    }
  }, [selectedTable?.table_no, selectedTable?.capacity, showBookingForm]);

  // Filter tables when floor_no or section changes
  useEffect(() => {
    filterTables();
  }, [allTables, selectedFloorNo, selectedSection]);

  // Load bookings when site, date, or filters change
  useEffect(() => {
    if (selectedSiteId) {
      loadBookings();
    }
  }, [selectedSiteId, selectedDate, selectedFloorNo, selectedSection, partySize]);

  // Generate grid based on tables
  useEffect(() => {
    if (tables.length > 0) {
      // Calculate grid dimensions based on number of tables
      // Arrange tables in a grid layout (approximately square)
      const numTables = tables.length;
      const cols = Math.ceil(Math.sqrt(numTables));
      const rows = Math.ceil(numTables / cols);
      
      const newGrid = [];
      let tableIndex = 0;
      
      for (let i = 0; i < rows; i++) {
        const row = [];
        for (let j = 0; j < cols; j++) {
          if (tableIndex < numTables) {
            const table = tables[tableIndex];
            row.push({ 
              id: `${i}-${j}`, 
              row: i, 
              col: j,
              table: table // Store table data in cell
            });
            tableIndex++;
          } else {
            row.push({ id: `${i}-${j}`, row: i, col: j, table: null });
          }
        }
        newGrid.push(row);
      }
      
      setGrid(newGrid);
      setGridRows(rows);
      setGridColumns(cols);
    } else if (selectedFloorNo) {
      // If no tables, show empty grid with default dimensions
      const defaultRows = 3;
      const defaultCols = 3;
      const newGrid = [];
      for (let i = 0; i < defaultRows; i++) {
        const row = [];
        for (let j = 0; j < defaultCols; j++) {
          row.push({ id: `${i}-${j}`, row: i, col: j, table: null });
        }
        newGrid.push(row);
      }
      setGrid(newGrid);
      setGridRows(defaultRows);
      setGridColumns(defaultCols);
    }
  }, [tables, selectedFloorNo]);

  // Handle mouse down for dragging
  const handleMouseDown = (e) => {
    const target = e.target;
    if (
      target.closest('button') || 
      target.closest('.grid-cell') ||
      target.tagName === 'BUTTON'
    ) {
      return;
    }
    
    if (grid.length > 0) {
      e.preventDefault();
      setIsDragging(true);
      dragStartRef.current = {
        x: e.clientX - position.x,
        y: e.clientY - position.y
      };
    }
  };

  // Add global mouse event listeners for dragging
  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e) => {
      setPosition({
        x: e.clientX - dragStartRef.current.x,
        y: e.clientY - dragStartRef.current.y
      });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  // Zoom handlers
  const handleZoomIn = () => {
    setZoom(Math.min(zoom + 10, 200));
  };

  const handleZoomOut = () => {
    setZoom(Math.max(zoom - 10, 50));
  };

  const loadSites = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Call the API to get sites
      const response = await getAllSites();
      
      // Handle different response formats
      const sitesData = Array.isArray(response) 
        ? response 
        : (response?.sites || response?.data || []);
      
      setSites(sitesData);
      
      // Log successful API call
      loggingService.logInfo(
        'booking_board_load_sites',
        `Successfully loaded ${sitesData.length} sites for booking board`,
        {
          endpoint: '/sites',
          method: 'GET',
          siteCount: sitesData.length,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log event:', logError);
      });
    } catch (err) {
      console.error('Error loading sites:', err);
      const errorMessage = err.message || 'Failed to load sites';
      setError(errorMessage);
      // Fallback to empty array on error
      setSites([]);
      
      // Log API error
      loggingService.logError(
        'booking_board_load_sites_error',
        `Failed to load sites for booking board: ${errorMessage}`,
        err,
        {
          endpoint: '/sites',
          method: 'GET',
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log error:', logError);
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loadAllTables = async () => {
    if (!selectedSiteId) return;
    try {
      setIsLoading(true);
      setError(null);
      
      // Call the API to get all tables for the site
      const filters = {
        site_id: selectedSiteId,
      };
      
      const response = await tableBookingApi.getTablesWithFilters(filters);
      const apiTables = response.tables || [];
      
      // Map API response to component format
      const tablesData = apiTables.map((table, index) => {
        // Generate default position based on index (for grid layout)
        const cols = Math.ceil(Math.sqrt(apiTables.length));
        const row = Math.floor(index / cols);
        const col = index % cols;
        const baseSize = 100;
        const spacing = 120;
        
        // Determine size based on capacity
        let size = { width: baseSize, height: baseSize };
        if (table.capacity) {
          if (table.capacity <= 2) {
            size = { width: 80, height: 80 };
          } else if (table.capacity <= 4) {
            size = { width: 100, height: 100 };
          } else if (table.capacity <= 6) {
            size = { width: 120, height: 120 };
          } else {
            size = { width: 140, height: 140 };
          }
        }
        
        // Determine shape (default to rectangle, can be enhanced later)
        const shape = 'rectangle';
        
        return {
          // Use API table_id when present (e.g. tbl_uuid), otherwise fallback for backward compatibility
          table_id: table.table_id || `table-${table.table_no || index}`,
          table_number: String(table.table_no || table.table_label || String(index + 1).padStart(2, '0')),
          table_no: table.table_no,
          capacity: table.capacity || 0,
          position: { 
            x: 50 + col * spacing, 
            y: 50 + row * spacing 
          },
          size: size,
          shape: shape,
          // Preserve API fields for reference
          section: table.section,
          floor_name: table.floor_name,
          floor_no: table.floor_no,
          table_label: table.table_label,
          floorplan_id: table.floorplan_id,
        };
      });
      
      setAllTables(tablesData);
      
      // Auto-select first floor_no if available and no floor is currently selected
      if (tablesData.length > 0) {
        const uniqueFloors = [...new Set(tablesData.map(t => t.floor_no).filter(f => f !== null && f !== undefined))].sort((a, b) => a - b);
        if (uniqueFloors.length > 0) {
          // Only auto-select if no floor is selected (i.e., when site first loads)
          // This check uses the current state value, which should be '' after reset
          setSelectedFloorNo(prev => prev || uniqueFloors[0].toString());
        }
      }
      
      // Log successful API call
      loggingService.logInfo(
        'booking_board_load_tables',
        `Successfully loaded ${tablesData.length} tables for site ${selectedSiteId}`,
        {
          endpoint: '/tables/tables',
          method: 'GET',
          siteId: selectedSiteId,
          tableCount: tablesData.length,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log event:', logError);
      });
    } catch (err) {
      console.error('Error loading tables:', err);
      const errorMessage = err.message || 'Failed to load tables';
      setError(errorMessage);
      // Fallback to empty array on error
      setAllTables([]);
      setTables([]);
      
      // Log API error
      loggingService.logError(
        'booking_board_load_tables_error',
        `Failed to load tables for site ${selectedSiteId}: ${errorMessage}`,
        err,
        {
          endpoint: '/tables/tables',
          method: 'GET',
          siteId: selectedSiteId,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log error:', logError);
      });
    } finally {
      setIsLoading(false);
    }
  };

  const filterTables = () => {
    let filtered = [...allTables];
    
    // Filter by floor_no
    if (selectedFloorNo) {
      filtered = filtered.filter(table => 
        table.floor_no !== null && 
        table.floor_no !== undefined && 
        table.floor_no.toString() === selectedFloorNo
      );
    }
    
    // Filter by section
    if (selectedSection) {
      filtered = filtered.filter(table => 
        table.section === selectedSection
      );
    }
    
    setTables(filtered);
  };

  /**
   * Load bookings from API using getTableBookings
   * API endpoint: GET /tables/bookings?site_id={siteId}&date={date}
   * Response format: { bookings: [{ booking_id, tenant_id, site_id, party_size, guest_name, 
   * guest_contact, guest_email, notes, booking_start, booking_end, table_no, status, ... }] }
   * Bookings are used in:
   * 1. Floor plan - to show table status (available/reserved/occupied/check_requested)
   * 2. Bookings List - to display all bookings for the selected date
   */
  const loadBookings = async () => {
    if (!selectedSiteId) return;
    try {
      setIsLoading(true);
      setError(null);
      
      // Call the API to get bookings
      // API returns array of bookings: [{ booking_id, tenant_id, site_id, party_size, guest_name, 
      // guest_contact, guest_email, notes, booking_start, booking_end, table_no, status, ... }]
      const bookingsArray = await tableBookingApi.getTableBookings(selectedSiteId, selectedDate);
      console.log('Bookings API response:', bookingsArray);

      // Ensure we have an array (API function should return array, but double-check for safety)
      const bookings = Array.isArray(bookingsArray) ? bookingsArray : [];
      
      // Map API response to component format (used for: right-side booking cards + left-side table status colors)
      // API may return table_id (UUID) and/or table_no; preserve both when present
      let bookingsData = bookings.map(booking => ({
        booking_id: booking.booking_id,
        tenant_id: booking.tenant_id,
        table_id: booking.table_id || (booking.table_no != null ? `table-${booking.table_no}` : null),
        table_no: booking.table_no != null ? Number(booking.table_no) : null,
        guest_name: booking.guest_name || '',
        guest_phone: booking.guest_contact || '', // Map guest_contact to guest_phone
        guest_email: booking.guest_email || '',
        party_size: booking.party_size,
        booking_time: booking.booking_start, // Use booking_start as booking_time
        slot_start: booking.booking_start,
        slot_end: booking.booking_end,
        status: booking.status,
        site_id: booking.site_id,
        special_requests: booking.notes || '',
        guest_contact_verified: booking.guest_contact_verified,
        estimated_dining_duration: booking.estimated_dining_duration,
        no_show_risk_score: booking.no_show_risk_score,
        table_merging_allowed_flag: booking.table_merging_allowed_flag,
        created_at: booking.created_at,
        updated_at: booking.updated_at,
      }));
      
      // Filter by selected floor_no and section if filters are applied.
      // Use allTables + current selectedFloorNo/selectedSection (not `tables` state) so we don't
      // rely on stale state when section changes (e.g. switching to 1A would otherwise use
      // previous section's tables and incorrectly hide the booking).
      if (selectedFloorNo || selectedSection) {
        let tablesForFilter = [...allTables];
        if (selectedFloorNo) {
          tablesForFilter = tablesForFilter.filter(
            t => t.floor_no != null && t.floor_no !== undefined && t.floor_no.toString() === selectedFloorNo
          );
        }
        if (selectedSection) {
          tablesForFilter = tablesForFilter.filter(t => t.section === selectedSection);
        }
        const filteredTableNumbers = tablesForFilter
          .map(t => (t.table_no != null ? Number(t.table_no) : parseInt(t.table_number, 10)))
          .filter(num => num !== null && num !== undefined && !Number.isNaN(num));
        const filteredTableIds = tablesForFilter.map(t => t.table_id).filter(Boolean);

        // Keep bookings that match by table_no OR by table_id (API may return either)
        if (filteredTableNumbers.length > 0 || filteredTableIds.length > 0) {
          bookingsData = bookingsData.filter(b => {
            if (b.table_no != null && filteredTableNumbers.includes(Number(b.table_no))) return true;
            if (b.table_id && filteredTableIds.includes(b.table_id)) return true;
            return false;
          });
        } else {
          bookingsData = [];
        }
      }
      
      // Filter by party size if specified
      if (partySize) {
        bookingsData = bookingsData.filter(b => b.party_size === parseInt(partySize));
      }

      console.log('Bookings (mapped for UI):', bookingsData);

      setBookings(bookingsData);
      
      // Log successful API call
      loggingService.logInfo(
        'booking_board_load_bookings',
        `Successfully loaded ${bookingsData.length} bookings for site ${selectedSiteId} on ${selectedDate}`,
        {
          endpoint: '/tables/bookings',
          method: 'GET',
          siteId: selectedSiteId,
          date: selectedDate,
          bookingCount: bookingsData.length,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log event:', logError);
      });
    } catch (err) {
      console.error('Error loading bookings:', err);
      const errorMessage = err.message || 'Failed to load bookings';
      setError(errorMessage);
      // Fallback to empty array on error
      setBookings([]);
      
      // Log API error
      loggingService.logError(
        'booking_board_load_bookings_error',
        `Failed to load bookings for site ${selectedSiteId} on ${selectedDate}: ${errorMessage}`,
        err,
        {
          endpoint: '/tables/bookings',
          method: 'GET',
          siteId: selectedSiteId,
          date: selectedDate,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log error:', logError);
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Bookings that overlap the time filter window (used for table grid + list)
  const bookingsInTimeRange = (() => {
    if (!selectedDate || !filterStartTime || !filterEndTime) return bookings;
    const filterRangeStart = new Date(`${selectedDate}T${filterStartTime}:00`);
    const filterRangeEnd = new Date(`${selectedDate}T${filterEndTime}:00`);
    return bookings.filter(b => {
      const bookingStart = new Date(b.slot_start || b.booking_time);
      const bookingEnd = b.slot_end ? new Date(b.slot_end) : bookingStart;
      return bookingStart < filterRangeEnd && bookingEnd > filterRangeStart;
    });
  })();

  const getTableStatus = (table) => {
    // Match by table number (table_no) or fallback to table_id for backward compatibility
    const tableNo = table.table_no !== null && table.table_no !== undefined
      ? Number(table.table_no)
      : parseInt(table.table_number, 10);
    if (Number.isNaN(tableNo)) return 'available';

    // Use time-filtered bookings when time filter is set, so grid reflects the selected window
    const sourceBookings = bookingsInTimeRange;

    const tableBookings = sourceBookings.filter(b => {
      if (b.table_no !== null && b.table_no !== undefined) {
        return Number(b.table_no) === tableNo;
      }
      if (b.table_id) {
        return b.table_id === table.table_id;
      }
      return false;
    });

    if (tableBookings.length === 0) return 'available';

    // When using time filter: any booking in tableBookings overlaps the window; take first. Otherwise: active = now in range
    const useTimeFilter = selectedDate && filterStartTime && filterEndTime;
    const currentBooking = useTimeFilter
      ? tableBookings[0]
      : tableBookings.find(b => {
          try {
            const bookingStart = new Date(b.booking_time || b.slot_start);
            const bookingEnd = b.slot_end ? new Date(b.slot_end) : null;
            const now = new Date();
            if (bookingEnd) return bookingStart <= now && bookingEnd >= now;
            return bookingStart <= now;
          } catch (error) {
            return false;
          }
        });

    if (!currentBooking) return 'available';

    const status = currentBooking.status?.toLowerCase();
    if (status === 'seated') return 'occupied';
    if (status === 'check_requested') return 'check_requested';
    if (status === 'booked' || status === 'confirmed' || status === 'reserved') return 'reserved';
    if (status === 'completed' || status === 'cancelled' || status === 'no_show') return 'available';
    return 'reserved';
  };

  // Get the current/active booking for a table for edit flow (uses time filter when set)
  const getCurrentBookingForTable = (table) => {
    const tableNo = table?.table_no !== null && table?.table_no !== undefined
      ? Number(table.table_no)
      : parseInt(table?.table_number, 10);
    if (table == null || Number.isNaN(tableNo)) return null;

    const sourceBookings = bookingsInTimeRange;
    const tableBookings = sourceBookings.filter(b => {
      if (b.table_no !== null && b.table_no !== undefined) {
        return Number(b.table_no) === tableNo;
      }
      if (b.table_id && table.table_id) return b.table_id === table.table_id;
      return false;
    });
    if (tableBookings.length === 0) return null;

    const useTimeFilter = selectedDate && filterStartTime && filterEndTime;
    if (useTimeFilter) return tableBookings[0];

    const now = new Date();
    const currentBooking = tableBookings.find(b => {
      try {
        const bookingStart = new Date(b.booking_time || b.slot_start);
        const bookingEnd = b.slot_end ? new Date(b.slot_end) : null;
        if (bookingEnd) return bookingStart <= now && bookingEnd >= now;
        return bookingStart <= now;
      } catch (error) {
        return false;
      }
    });
    return currentBooking || null;
  };

  const getTableStatusColor = (status) => {
    switch (status) {
      case 'available':
        return { bg: 'bg-green-500', border: 'border-green-600', text: 'text-white' };
      case 'reserved':
        return { bg: 'bg-yellow-500', border: 'border-yellow-600', text: 'text-white' };
      case 'occupied':
        return { bg: 'bg-red-500', border: 'border-red-600', text: 'text-white' };
      case 'check_requested':
        return { bg: 'bg-orange-500', border: 'border-orange-600', text: 'text-white' };
      default:
        return { bg: 'bg-gray-500', border: 'border-gray-600', text: 'text-white' };
    }
  };

  const handleCreateBooking = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!selectedSiteId) {
      setError('Please select a site');
      setTimeout(() => setError(null), 3000);
      return;
    }
    
    if (!bookingForm.guest_name || !bookingForm.guest_phone || !bookingForm.party_size || 
        !bookingForm.booking_date || !bookingForm.start_time || !bookingForm.end_time) {
      setError('Please fill in all required fields including start time and end time');
      setTimeout(() => setError(null), 3000);
      return;
    }

    // Booking date cannot be in the past
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    if (bookingForm.booking_date < todayStr) {
      setError('Booking date cannot be in the past');
      setTimeout(() => setError(null), 3000);
      return;
    }

    // When booking is for today: allow start in the past only if end time is still in the future (e.g. filter pre-fill or walk-in)
    if (bookingForm.booking_date === todayStr && bookingForm.start_time && bookingForm.end_time) {
      const currentTimeStr = `${String(today.getHours()).padStart(2, '0')}:${String(today.getMinutes()).padStart(2, '0')}`;
      const startInPast = bookingForm.start_time <= currentTimeStr;
      const endInPast = bookingForm.end_time <= currentTimeStr;
      if (startInPast && endInPast) {
        setError('Booking slot is in the past. Please select a start and end time that includes the current time or future.');
        setTimeout(() => setError(null), 3000);
        return;
      }
    }
    
    // Validate that end time is after start time
    if (bookingForm.start_time && bookingForm.end_time) {
      if (bookingForm.end_time <= bookingForm.start_time) {
        setError('End time must be after start time');
        setTimeout(() => setError(null), 3000);
        return;
      }
    }

    // Party size cannot exceed selected table capacity
    if (selectedTable) {
      const tableCapacity = Number(selectedTable.capacity) || 0;
      const requestedPartySize = parseInt(bookingForm.party_size, 10);
      if (!isNaN(requestedPartySize) && tableCapacity > 0 && requestedPartySize > tableCapacity) {
        setError(`Party size cannot exceed table capacity (${tableCapacity} seats)`);
        setTimeout(() => setError(null), 3000);
        return;
      }
    }

    try {
      setIsLoading(true);
      setError(null);
      
      // Booking times in IST (Indian Standard Time, UTC+5:30)
      // Format: YYYY-MM-DDTHH:mm:ss+05:30
      const IST_OFFSET = '+05:30';
      const bookingStartIST = `${bookingForm.booking_date}T${bookingForm.start_time}:00${IST_OFFSET}`;
      const bookingEndIST = `${bookingForm.booking_date}T${bookingForm.end_time}:00${IST_OFFSET}`;

      const startDate = new Date(bookingStartIST);
      const endDate = new Date(bookingEndIST);
      const estimatedDuration = Math.round((endDate - startDate) / (1000 * 60)); // duration in minutes

      // (Previously UTC: toISOString() converted to Z; now using IST explicitly)
      // const bookingStart = new Date(`${bookingForm.booking_date}T${bookingForm.start_time}:00`);
      // const bookingEnd = new Date(`${bookingForm.booking_date}T${bookingForm.end_time}:00`);
      // booking_start: bookingStart.toISOString(),
      // booking_end: bookingEnd.toISOString(),

      // Extract table information from selected table
      const tableId = selectedTable?.table_id;
      const tableNo = selectedTable?.table_no 
        ? parseInt(selectedTable.table_no) 
        : selectedTable?.table_number 
          ? parseInt(selectedTable.table_number) 
          : undefined;
      const floorNo = selectedTable?.floor_no !== null && selectedTable?.floor_no !== undefined
        ? parseInt(selectedTable.floor_no)
        : undefined;
      
      // Prepare API request data (booking_start, booking_end in IST)
      const bookingData = {
        site_id: selectedSiteId,
        party_size: parseInt(bookingForm.party_size),
        guest_contact: bookingForm.guest_phone,
        estimated_dining_duration: estimatedDuration,
        no_show_risk_score: 0.15, // Default risk score
        table_merging_allowed_flag: false, // Default to false
        booking_start: bookingStartIST,
        booking_end: bookingEndIST,
        status: 'booked', // Default status
        guest_name: bookingForm.guest_name,
        guest_email: bookingForm.guest_email || '',
        notes: bookingForm.special_requests || '',
      };
      
      // Add table identifier - prefer table_id, otherwise use table_no + floor_no
      if (tableId) {
        bookingData.table_id = tableId;
      } else if (tableNo) {
        bookingData.table_no = tableNo;
        if (floorNo !== undefined) {
          bookingData.floor_no = floorNo;
        }
      }

      // Log the payload we send when creating a booking
      console.log('Create booking payload:', JSON.stringify(bookingData, null, 2));
      
      // Call the API
      const response = await tableBookingApi.createTableBooking(bookingData);
      const bookingId = response?.booking_id ?? response?.data?.booking_id ?? response?.id;

      // Success - reload bookings to get the updated list
      setSuccess('Booking created successfully!');
      setShowBookingForm(false);
      setBookingForm({
        guest_name: '',
        guest_phone: '',
        guest_email: '',
        party_size: '',
        booking_date: new Date().toISOString().split('T')[0],
        booking_time: '',
        start_time: '',
        end_time: '',
        table_id: '',
        table_no: '',
        special_requests: '',
      });
      setSelectedTable(null);
      
      // Log successful API call
      loggingService.logInfo(
        'booking_board_create_booking',
        `Successfully created booking ${bookingId} for site ${selectedSiteId}`,
        {
          endpoint: '/tables/bookings',
          method: 'POST',
          siteId: selectedSiteId,
          bookingId: bookingId,
          partySize: bookingData.party_size,
          tableId: bookingData.table_id || null,
          tableNo: bookingData.table_no || null,
          bookingStart: bookingData.booking_start,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log event:', logError);
      });
      
      // Reload bookings to reflect the new booking
      await loadBookings();
    } catch (err) {
      console.error('Error creating booking:', err);
      const errorMessage =
        err.responseData?.error ||
        err.responseData?.message ||
        err.responseData?.detail ||
        err.message ||
        'Failed to create booking';
      setError(`Failed to create booking: ${errorMessage}`);
      setTimeout(() => setError(null), 5000);
      
      // Log API error
      loggingService.logError(
        'booking_board_create_booking_error',
        `Failed to create booking for site ${selectedSiteId}: ${errorMessage}`,
        err,
        {
          endpoint: '/tables/bookings',
          method: 'POST',
          siteId: selectedSiteId,
          bookingData: {
            partySize: bookingData.party_size,
            tableId: bookingData.table_id || null,
            tableNo: bookingData.table_no || null,
          },
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log error:', logError);
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateBooking = async (e) => {
    e.preventDefault();
    if (!editingBookingId) {
      handleCreateBooking(e);
      return;
    }
    // Same validation as create
    if (!selectedSiteId) {
      setError('Please select a site');
      setTimeout(() => setError(null), 3000);
      return;
    }
    if (!bookingForm.guest_name || !bookingForm.guest_phone || !bookingForm.party_size ||
        !bookingForm.booking_date || !bookingForm.start_time || !bookingForm.end_time) {
      setError('Please fill in all required fields including start time and end time');
      setTimeout(() => setError(null), 3000);
      return;
    }
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    if (bookingForm.booking_date < todayStr) {
      setError('Booking date cannot be in the past');
      setTimeout(() => setError(null), 3000);
      return;
    }
    const currentTimeStr = `${String(today.getHours()).padStart(2, '0')}:${String(today.getMinutes()).padStart(2, '0')}`;
    const isNowWithinBooking = bookingForm.booking_date === todayStr && bookingForm.start_time && bookingForm.end_time &&
      currentTimeStr >= bookingForm.start_time && currentTimeStr < bookingForm.end_time;
    if (bookingForm.booking_date === todayStr && bookingForm.start_time && !isNowWithinBooking) {
      if (bookingForm.start_time <= currentTimeStr) {
        setError('Start time cannot be in the past. Please select a future time.');
        setTimeout(() => setError(null), 3000);
        return;
      }
    }
    if (bookingForm.start_time && bookingForm.end_time && bookingForm.end_time <= bookingForm.start_time) {
      setError('End time must be after start time');
      setTimeout(() => setError(null), 3000);
      return;
    }
    if (selectedTable) {
      const tableCapacity = Number(selectedTable.capacity) || 0;
      const requestedPartySize = parseInt(bookingForm.party_size, 10);
      if (!isNaN(requestedPartySize) && tableCapacity > 0 && requestedPartySize > tableCapacity) {
        setError(`Party size cannot exceed table capacity (${tableCapacity} seats)`);
        setTimeout(() => setError(null), 3000);
        return;
      }
    }

    try {
      setIsLoading(true);
      setError(null);
      const IST_OFFSET = '+05:30';
      const bookingStartIST = `${bookingForm.booking_date}T${bookingForm.start_time}:00${IST_OFFSET}`;
      const bookingEndIST = `${bookingForm.booking_date}T${bookingForm.end_time}:00${IST_OFFSET}`;
      const startDate = new Date(bookingStartIST);
      const endDate = new Date(bookingEndIST);
      const estimatedDuration = Math.round((endDate - startDate) / (1000 * 60));
      const tableId = selectedTable?.table_id;
      const tableNo = selectedTable?.table_no != null ? parseInt(selectedTable.table_no) : selectedTable?.table_number != null ? parseInt(selectedTable.table_number) : undefined;
      const floorNo = selectedTable?.floor_no !== null && selectedTable?.floor_no !== undefined ? parseInt(selectedTable.floor_no) : undefined;

      const bookingData = {
        site_id: selectedSiteId,
        party_size: parseInt(bookingForm.party_size),
        guest_contact: bookingForm.guest_phone,
        estimated_dining_duration: estimatedDuration,
        no_show_risk_score: 0.15,
        table_merging_allowed_flag: false,
        booking_start: bookingStartIST,
        booking_end: bookingEndIST,
        status: 'booked',
        guest_name: bookingForm.guest_name,
        guest_email: bookingForm.guest_email || '',
        notes: bookingForm.special_requests || '',
      };
      if (tableId) bookingData.table_id = tableId;
      else if (tableNo !== undefined) {
        bookingData.table_no = tableNo;
        if (floorNo !== undefined) bookingData.floor_no = floorNo;
      }

      await tableBookingApi.updateBooking(editingBookingId, bookingData);
      setSuccess('Booking updated successfully!');
      setShowBookingForm(false);
      setEditingBookingId(null);
      setBookingForm({
        guest_name: '',
        guest_phone: '',
        guest_email: '',
        party_size: '',
        booking_date: new Date().toISOString().split('T')[0],
        booking_time: '',
        start_time: '',
        end_time: '',
        table_id: '',
        table_no: '',
        special_requests: '',
      });
      setSelectedTable(null);
      
      // Log successful API call
      loggingService.logInfo(
        'booking_board_update_booking',
        `Successfully updated booking ${editingBookingId} for site ${selectedSiteId}`,
        {
          endpoint: `/tables/bookings/${editingBookingId}`,
          method: 'PUT',
          siteId: selectedSiteId,
          bookingId: editingBookingId,
          partySize: bookingData.party_size,
          tableId: bookingData.table_id || null,
          tableNo: bookingData.table_no || null,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log event:', logError);
      });
      
      await loadBookings();
      setTimeout(() => setSuccess(null), 5000);
    } catch (err) {
      console.error('Error updating booking:', err);
      const errorMessage = err.responseData?.error || err.message || 'Failed to update booking';
      setError(`Failed to update booking: ${errorMessage}`);
      setTimeout(() => setError(null), 5000);
      
      // Log API error
      loggingService.logError(
        'booking_board_update_booking_error',
        `Failed to update booking ${editingBookingId} for site ${selectedSiteId}: ${errorMessage}`,
        err,
        {
          endpoint: `/tables/bookings/${editingBookingId}`,
          method: 'PUT',
          siteId: selectedSiteId,
          bookingId: editingBookingId,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log error:', logError);
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteBooking = async (bookingId) => {
    if (!bookingId) {
      setError('Booking ID is required');
      setTimeout(() => setError(null), 3000);
      return;
    }
    
    if (!window.confirm('Are you sure you want to delete this booking?')) return;
    
    try {
      setIsLoading(true);
      setError(null);
      
      // Call the API to delete the booking
      await tableBookingApi.deleteTableBooking(bookingId);
      
      // Remove booking from local state
      setBookings(prev => prev.filter(b => b.booking_id !== bookingId));
      
      // Show success message (user dismisses via SuccessOverlay Done button)
      setSuccess('Booking deleted successfully!');

      // Log successful API call
      loggingService.logInfo(
        'booking_board_delete_booking',
        `Successfully deleted booking ${bookingId} for site ${selectedSiteId}`,
        {
          endpoint: `/tables/bookings/${bookingId}`,
          method: 'DELETE',
          siteId: selectedSiteId,
          bookingId: bookingId,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log event:', logError);
      });

      // Optionally reload bookings to ensure consistency with server
      // await loadBookings();
    } catch (err) {
      console.error('Error deleting booking:', err);
      const errorMessage = err.responseData?.error || err.message || 'Failed to delete booking';
      setError(`Failed to delete booking: ${errorMessage}`);
      setTimeout(() => setError(null), 5000);
      
      // Log API error
      loggingService.logError(
        'booking_board_delete_booking_error',
        `Failed to delete booking ${bookingId} for site ${selectedSiteId}: ${errorMessage}`,
        err,
        {
          endpoint: `/tables/bookings/${bookingId}`,
          method: 'DELETE',
          siteId: selectedSiteId,
          bookingId: bookingId,
        }
      ).catch(logError => {
        console.warn('[BookingBoard] Failed to log error:', logError);
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Resolve table display name for a booking by matching table_id (or table_no) to allTables
  const getTableDisplayNameForBooking = (booking) => {
    if (!allTables.length) {
      if (booking.table_no != null && booking.table_no !== undefined) return String(booking.table_no);
      if (booking.table_id) return booking.table_id.slice(-6);
      return null;
    }
    if (booking.table_id) {
      const table = allTables.find(t => t.table_id === booking.table_id);
      if (table) return table.table_number ?? table.table_no ?? String(table.table_id?.slice(-6) ?? '');
    }
    if (booking.table_no != null && booking.table_no !== undefined) {
      const table = allTables.find(t =>
        (t.table_no != null && Number(t.table_no) === Number(booking.table_no)) ||
        (t.table_number != null && Number(t.table_number) === Number(booking.table_no))
      );
      if (table) return table.table_number ?? table.table_no ?? String(booking.table_no);
      return String(booking.table_no);
    }
    return null;
  };

  // Right: Bookings List — time filter already applied in bookingsInTimeRange; add search filter
  const filteredBookings = bookingsInTimeRange.filter(booking => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    const tableName = getTableDisplayNameForBooking(booking);
    return (
      booking.guest_name?.toLowerCase().includes(query) ||
      booking.guest_phone?.includes(query) ||
      booking.guest_email?.toLowerCase().includes(query) ||
      booking.table_id?.toLowerCase().includes(query) ||
      (booking.table_no !== null && booking.table_no !== undefined && booking.table_no.toString().includes(query)) ||
      (tableName && tableName.toLowerCase().includes(query))
    );
  });

  // Edit mode: true when current time is within the booking slot (user can only edit end time)
  const isEditModeAndNowWithinBooking = Boolean(
    editingBookingId &&
    bookingForm.booking_date &&
    bookingForm.start_time &&
    bookingForm.end_time &&
    (() => {
      const now = new Date();
      const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      if (bookingForm.booking_date !== todayStr) return false;
      const currentTimeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      return currentTimeStr >= bookingForm.start_time && currentTimeStr < bookingForm.end_time;
    })()
  );

  const getStatusBadge = (status) => {
    const badges = {
      booked: { bg: 'bg-yellow-100', text: 'text-yellow-800', icon: Clock },
      confirmed: { bg: 'bg-blue-100', text: 'text-blue-800', icon: CheckCircle2 },
      seated: { bg: 'bg-green-100', text: 'text-green-800', icon: Users },
      completed: { bg: 'bg-gray-100', text: 'text-gray-800', icon: CheckCircle2 },
      no_show: { bg: 'bg-red-100', text: 'text-red-800', icon: AlertCircle },
      cancelled: { bg: 'bg-red-100', text: 'text-red-800', icon: X },
      check_requested: { bg: 'bg-orange-100', text: 'text-orange-800', icon: AlertCircle },
      reserved: { bg: 'bg-yellow-100', text: 'text-yellow-800', icon: Clock }, // Legacy support
    };
    const badge = badges[status] || badges.booked;
    const Icon = badge.icon;
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${badge.bg} ${badge.text}`}>
        <Icon className="w-3 h-3" />
        {status.replace('_', ' ')}
      </span>
    );
  };

  return (
    <div className="flex flex-col h-full gap-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-1">Table Booking</h1>
          <p className="text-gray-600">Manage reservations and table assignments</p>
        </div>
        
      </div>

      {/* Alerts */}
      {error && (
        <div className="flex items-center gap-2 p-4 bg-red-50 border border-red-200 rounded-xl text-red-700">
          <AlertCircle className="w-5 h-5" />
          {error}
        </div>
      )}
      <SuccessOverlay
        open={!!success}
        title={success || ''}
        onClose={() => setSuccess(null)}
      />

      {/* Filters */}
      <Card className="p-6" style={panelStyle}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
              <MapPin className="w-4 h-4" />
              Site
            </label>
            <select
              value={selectedSiteId}
              onChange={(e) => {
                setSelectedSiteId(e.target.value);
                setSelectedFloorPlan(null);
                setSelectedFloorNo('');
                setSelectedSection('');
              }}
              className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
            >
              <option value="">Select a site</option>
              {Array.isArray(sites) && [...sites]
                    .sort((a, b) => {
            const nameA = (a.site_name || a.name || 'Unknown Site').toLowerCase();
            const nameB = (b.site_name || b.name || 'Unknown Site').toLowerCase();
                      return nameA.localeCompare(nameB);
                    })
                    .map((site) => (
                      <option key={site.site_id || site.id} value={site.site_id || site.id}>
                        {site.site_name || site.name || 'Unknown Site'}
                      </option>
                    ))}
            </select>
          </div>

          <div>
            <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
              <Calendar className="w-4 h-4" />
              Date
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
            />
          </div>

          <div>
            <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
              <Clock className="w-4 h-4" />
              Start time
            </label>
            <input
              type="time"
              value={filterStartTime}
              onChange={(e) => {
                const newStart = e.target.value;
                setFilterStartTime(newStart);
                // Set end time to one hour after new start (cap at 23:59)
                const [h, m] = newStart.split(':').map(Number);
                const endMinutes = h * 60 + m + 60;
                const endH = endMinutes >= 24 * 60 ? 23 : Math.floor(endMinutes / 60);
                const endM = endMinutes >= 24 * 60 ? 59 : endMinutes % 60;
                setFilterEndTime(`${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`);
              }}
              className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
            />
          </div>

          <div>
            <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
              <Clock className="w-4 h-4" />
              End time
            </label>
            <input
              type="time"
              value={filterEndTime}
              onChange={(e) => setFilterEndTime(e.target.value)}
              className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
            />
          </div>

          {/* <div>
            <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
              <Users className="w-4 h-4" />
              Party Size
            </label>
            <input
              type="number"
              value={partySize}
              onChange={(e) => setPartySize(e.target.value)}
              placeholder="Any"
              className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
            />
          </div> */}
        </div>

        {/* Floor No Dropdown and Section Tabs */}
        {selectedSiteId && allTables.length > 0 && (
          <div className="mt-4 space-y-4">
            {/* Floor No Dropdown */}
            <div>
              <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                <MapPin className="w-4 h-4" />
                Floor
              </label>
              <select
                value={selectedFloorNo}
                onChange={(e) => {
                  setSelectedFloorNo(e.target.value);
                  setSelectedSection(''); // Reset section when floor changes
                }}
                className="min-w-[320px] min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
              >
                <option value="">All Floors</option>
                {[...new Set(allTables.map(t => t.floor_no).filter(f => f !== null && f !== undefined))]
                  .sort((a, b) => a - b)
                  .map((floorNo) => {
                    const floorName = allTables.find(t => t.floor_no === floorNo)?.floor_name || `Floor ${floorNo}`;
                    return (
                      <option key={floorNo} value={floorNo.toString()}>
                        {floorName}
                      </option>
                    );
                  })}
              </select>
            </div>

            {/* Section Tabs */}
            {selectedFloorNo && (() => {
              const sectionsForFloor = [...new Set(
                allTables
                  .filter(t => t.floor_no !== null && t.floor_no !== undefined && t.floor_no.toString() === selectedFloorNo)
                  .map(t => t.section)
                  .filter(s => s)
              )];
              
              if (sectionsForFloor.length > 0) {
                return (
                  <div>
                    <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                      Section
                    </label>
                    <div className="flex gap-2 flex-wrap">
                      {sectionsForFloor.map((section) => (
                        <button
                          key={section}
                          onClick={() => setSelectedSection(section)}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                            selectedSection === section
                              ? 'bg-green-500 text-white shadow-lg'
                              : 'bg-white text-gray-700 hover:bg-gray-50'
                          }`}
                        >
                          {section}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              }
              return null;
            })()}
          </div>
        )}
      </Card>

      {/* Main Content */}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-6 overflow-hidden min-h-0">
        {/*  className="grid grid-cols-1 md:grid-cols-3 gap-4" */}
        <div className="lg:col-span-2">
          <Card className="h-full flex flex-col rounded-2xl overflow-hidden" style={panelStyle}>
            <div className="px-6 py-4 border-b border-white/30 bg-white/40 backdrop-blur-sm">
              <div className="flex items-center justify-between mb-3">
                <h2 className="text-lg font-semibold text-gray-900">
                  {selectedFloorNo && selectedSection 
                    ? `${allTables.find(t => t.floor_no?.toString() === selectedFloorNo)?.floor_name || `Floor ${selectedFloorNo}`} - ${selectedSection}`
                    : selectedFloorNo 
                      ? (allTables.find(t => t.floor_no?.toString() === selectedFloorNo)?.floor_name || `Floor ${selectedFloorNo}`)
                      : selectedSiteId
                        ? 'Select Floor and Section'
                        : 'Select a Site'}
                </h2>
                <Button
                  onClick={() => {
                    const isReserved = selectedTable && getTableStatus(selectedTable) === 'reserved';
                    if (isReserved) {
                      const currentBooking = getCurrentBookingForTable(selectedTable);
                      if (currentBooking) {
                        // Use API start/end strings so we display exactly what the API has (e.g. 14:00 from "2026-02-10T14:00:00+05:30")
                        const startStr = currentBooking.booking_time || currentBooking.slot_start;
                        const endStr = currentBooking.slot_end;
                        const startTime = typeof startStr === 'string' && startStr.includes('T')
                          ? startStr.split('T')[1].slice(0, 5)
                          : (() => { const d = new Date(startStr); return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; })();
                        const endTime = (typeof endStr === 'string' && endStr.includes('T'))
                          ? endStr.split('T')[1].slice(0, 5)
                          : (endStr ? (() => { const d = new Date(endStr); return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; })() : startTime);
                        const startDate = new Date(startStr);
                        const bookingDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
                        setBookingForm({
                          guest_name: currentBooking.guest_name || '',
                          guest_phone: currentBooking.guest_phone || currentBooking.guest_contact || '',
                          guest_email: currentBooking.guest_email || '',
                          party_size: String(currentBooking.party_size ?? ''),
                          booking_date: bookingDate,
                          booking_time: startTime,
                          start_time: startTime,
                          end_time: endTime,
                          table_id: selectedTable.table_id || '',
                          table_no: selectedTable.table_no || selectedTable.table_number || '',
                          special_requests: currentBooking.special_requests || currentBooking.notes || '',
                        });
                        setEditingBookingId(currentBooking.booking_id);
                      } else {
                        setEditingBookingId(null);
                      }
                    } else {
                      setEditingBookingId(null);
                      // New Booking: pre-fill start time, end time, and date from the filter
                      setBookingForm(prev => ({
                        ...prev,
                        booking_date: selectedDate || prev.booking_date,
                        start_time: filterStartTime || prev.start_time,
                        end_time: filterEndTime || prev.end_time,
                        booking_time: filterStartTime || prev.booking_time,
                      }));
                    }
                    setShowBookingForm(true);
                  }}
                  disabled={!selectedSiteId || !selectedFloorNo || !selectedSection || !selectedTable}
                  className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-xl shadow-lg disabled:opacity-40 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed disabled:hover:bg-gray-400 disabled:hover:opacity-40"
                >
                  <Plus className="w-5 h-5" />
                  {selectedTable && getTableStatus(selectedTable) === 'reserved' ? 'Edit Booking' : 'New Booking'}
                </Button>
              </div>
              {/* Status Legend */}
              <div className="flex items-center gap-4 flex-wrap">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded-full bg-green-500 border-2 border-green-600"></div>
                  <span className="text-sm text-gray-700 font-medium">Available</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded-full bg-yellow-500 border-2 border-yellow-600"></div>
                  <span className="text-sm text-gray-700 font-medium">Reserved</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded-full bg-red-500 border-2 border-red-600"></div>
                  <span className="text-sm text-gray-700 font-medium">Occupied</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 rounded-full bg-orange-500 border-2 border-orange-600"></div>
                  <span className="text-sm text-gray-700 font-medium">Check Requested</span>
                </div>
              </div>
            </div>
            <div 
              ref={gridParentRef}
              className="flex-1 p-6 flex flex-col items-center justify-center relative overflow-hidden"
              style={{ cursor: grid.length > 0 && !isDragging ? 'grab' : isDragging ? 'grabbing' : 'default' }}
              onMouseDown={handleMouseDown}
            >
              {/* Zoom Controls */}
              {grid.length > 0 && tables.length > 0 && (
                <div className="absolute top-4 right-4 z-10">
                  <div className="bg-white/90 rounded-lg border border-gray-200 shadow-sm flex flex-col">
                    <button
                      type="button"
                      onClick={handleZoomIn}
                      className="p-2 hover:bg-gray-100 transition-colors rounded-t-lg"
                      aria-label="Zoom in"
                    >
                      <Plus className="w-4 h-4 text-gray-600" strokeWidth={2} />
                    </button>
                    <div className="border-t border-gray-200"></div>
                    <button
                      type="button"
                      onClick={handleZoomOut}
                      className="p-2 hover:bg-gray-100 transition-colors rounded-b-lg"
                      aria-label="Zoom out"
                    >
                      <Minus className="w-4 h-4 text-gray-600" strokeWidth={2} />
                    </button>
                  </div>
                </div>
              )}

              {/* Grid Container */}
              {isLoading && tables.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-gray-400">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500 mb-2"></div>
                  <p className="text-sm mt-2">Loading tables...</p>
                </div>
              ) : grid.length > 0 ? (
                <div
                  ref={gridContainerRef}
                  className="grid-container flex flex-col items-center justify-center gap-2 select-none pointer-events-none"
                  style={{ 
                    transform: `translate(${position.x}px, ${position.y}px) scale(${zoom / 100})`, 
                    transformOrigin: 'center'
                  }}
                >
                  {/* Grid */}
                  <div className="flex flex-col gap-1 pointer-events-auto">
                    {grid.map((row, rowIndex) => (
                      <div key={rowIndex} className="flex gap-1">
                        {row.map((cell) => {
                          const table = cell.table;
                          if (!table) {
                            return (
                              <div
                                key={cell.id}
                                className="grid-cell w-16 h-16 bg-gray-100 border-2 border-gray-200 rounded-sm flex items-center justify-center"
                                style={{ minWidth: '64px', minHeight: '64px' }}
                              />
                            );
                          }

                          const status = getTableStatus(table);
                          const colors = getTableStatusColor(status);
                          const isSelected = selectedTable?.table_id === table.table_id;

                          return (
                            <div
                              key={cell.id}
                              onClick={() => {
                                setSelectedTable(table);
                                setBookingForm(prev => ({ 
                                  ...prev, 
                                  table_id: table.table_id,
                                  table_no: table.table_no || table.table_number
                                }));
                              }}
                              className={`grid-cell w-16 h-16 ${colors.bg} ${colors.border} border-2 rounded-sm flex flex-col items-center justify-center cursor-pointer hover:scale-105 transition-all shadow-md ${
                                isSelected ? 'ring-4 ring-green-400 ring-offset-2 scale-105' : ''
                              }`}
                              style={{ minWidth: '64px', minHeight: '64px' }}
                            >
                              <div className={`${colors.text} font-bold text-xs`}>
                                T-{table.table_number || table.table_no || table.table_id?.slice(-2)}
                              </div>
                              <div className={`${colors.text} text-[10px] mt-0.5`}>
                                S-{table.capacity || 0}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </div>
              ) : selectedSiteId && allTables.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-gray-400 py-8">
                  <MapPin className="w-12 h-12 mb-2 opacity-50" />
                  <p className="text-lg font-medium">No tables found</p>
                  <p className="text-sm mt-2">No tables available for this site</p>
                </div>
              ) : selectedFloorNo && tables.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-gray-400 py-8">
                  <MapPin className="w-12 h-12 mb-2 opacity-50" />
                  <p className="text-lg font-medium">No tables found</p>
                  <p className="text-sm mt-2">No tables match the selected filters</p>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center text-gray-400">
                  <p className="text-lg font-medium">Select a site to view tables</p>
                  <p className="text-sm mt-2">Choose a site, floor, and section to display tables</p>
                </div>
              )}
            </div>
          </Card>
        </div>

        {/* Right: Bookings List */}
        <div className="lg:col-span-1">
          <Card className="h-full flex flex-col rounded-2xl overflow-hidden" style={panelStyle}>
            <div className="px-6 py-4 border-b border-white/30 bg-white/40 backdrop-blur-sm flex items-center justify-between flex-shrink-0">
              <h2 className="text-lg font-semibold text-gray-900">Bookings</h2>
              <span className="text-sm text-gray-600 bg-white/50 px-3 py-1 rounded-full">
                {filteredBookings.length}
              </span>
            </div>
            
            {/* Search Bar */}
            <div className="px-6 py-4 border-b border-white/30 bg-white/20 backdrop-blur-sm flex-shrink-0">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search bookings..."
                  className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white pl-10 pr-4 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                />
              </div>
            </div>
            
            <div className="overflow-y-auto p-4 space-y-3" style={{ height: '700px' }}>
              {isLoading && bookings.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full text-gray-400">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-500 mb-2"></div>
                  <p>Loading bookings...</p>
                </div>
              ) : filteredBookings.length > 0 ? (
                filteredBookings.map((booking) => {
                  const bookingTime = new Date(booking.booking_time || booking.slot_start);
                  const bookingEnd = booking.slot_end ? new Date(booking.slot_end) : null;
                  const isPast = bookingTime < new Date();
                  const duration = booking.estimated_dining_duration || 
                    (bookingEnd ? Math.round((bookingEnd - bookingTime) / (1000 * 60)) : null);
                  
                  return (
                    <div
                      key={booking.booking_id}
                      className={`p-4 rounded-xl border transition-all hover:shadow-lg ${
                        isPast ? 'bg-gray-50 border-gray-200' : 'bg-white border-gray-200'
                      }`}
                    >
                      <div className="flex items-start justify-between mb-2">
                        <div className="flex-1">
                          <h3 className="font-semibold text-gray-900 mb-1">
                            {booking.guest_name || 'Guest'}
                          </h3>
                          <div className="flex flex-col gap-1 text-xs text-gray-600 mb-2">
                            <div className="flex items-center gap-2">
                              <Clock className="w-3 h-3" />
                              <span>
                                {bookingTime.toLocaleDateString([], { month: 'short', day: 'numeric' })}
                                {' '}
                                {bookingTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                              </span>
                            </div>
                            {duration && (
                              <div className="text-xs text-gray-500 ml-5">
                                Duration: {duration} min
                              </div>
                            )}
                          </div>
                        </div>
                        {getStatusBadge(booking.status)}
                      </div>
                      <div className="space-y-1 text-sm text-gray-600">
                        <div className="flex items-center gap-2">
                          <Users className="w-4 h-4" />
                          Party of {booking.party_size}
                        </div>
                        {(() => {
                          const tableName = getTableDisplayNameForBooking(booking);
                          return tableName ? (
                            <div className="flex items-center gap-2">
                              <MapPin className="w-4 h-4" />
                              Table {tableName}
                            </div>
                          ) : (
                            <div className="flex items-center gap-2 text-gray-400">
                              <MapPin className="w-4 h-4" />
                              No table assigned
                            </div>
                          );
                        })()}
                        {booking.guest_phone && (
                          <div className="flex items-center gap-2">
                            <Phone className="w-4 h-4" />
                            <span>{booking.guest_phone}</span>
                            {booking.guest_contact_verified && (
                              <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                                Verified
                              </span>
                            )}
                          </div>
                        )}
                        {booking.guest_email && (
                          <div className="flex items-center gap-2">
                            <Mail className="w-4 h-4" />
                            {booking.guest_email}
                          </div>
                        )}
                        {booking.special_requests && (
                          <div className="mt-2 pt-2 border-t border-gray-200">
                            <p className="text-xs text-gray-500 italic">
                              {booking.special_requests}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="mt-3 flex gap-2">
                        <button
                          onClick={() => handleDeleteBooking(booking.booking_id)}
                          className="flex-1 px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                        >
                          <Trash2 className="w-3 h-3 inline mr-1" />
                          Delete
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="flex flex-col items-center justify-center h-full text-gray-400 py-8">
                  <Calendar className="w-12 h-12 mb-2 opacity-50" />
                  <p className="font-medium mb-1">No bookings found</p>
                  <p className="text-xs text-gray-400">
                    {selectedSiteId && selectedDate 
                      ? `No bookings for ${new Date(selectedDate).toLocaleDateString([], { month: 'long', day: 'numeric', year: 'numeric' })}`
                      : 'Select a site and date to view bookings'}
                  </p>
                </div>
              )}
            </div>
          </Card>
        </div>
      </div>

      {/* Booking Form Modal */}
      {showBookingForm && createPortal(
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 overflow-y-auto">
          <Card.Light className="w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4 border-b border-gray-200 bg-white/70 backdrop-blur-sm flex items-center justify-between gap-3 sticky top-0">
              <div className="flex items-center gap-3 min-w-0">
                <h2 className="text-xl font-semibold text-gray-900 shrink-0">{editingBookingId ? 'Edit Booking' : 'Create New Booking'}</h2>
                {editingBookingId && bookingForm.start_time && bookingForm.end_time && (
                  <span className="text-sm text-gray-600 whitespace-nowrap">
                    Start time: <span className="font-medium">{bookingForm.start_time}</span>
                    <span className="mx-1.5 text-gray-400">–</span>
                    End time: <span className="font-medium">{bookingForm.end_time}</span>
                  </span>
                )}
              </div>
              <button
                onClick={() => {
                  setShowBookingForm(false);
                  setEditingBookingId(null);
                  setBookingForm({
                    guest_name: '',
                    guest_phone: '',
                    guest_email: '',
                    party_size: '',
                    booking_date: new Date().toISOString().split('T')[0],
                    booking_time: '',
                    start_time: '',
                    end_time: '',
                    table_id: '',
                    table_no: '',
                    special_requests: '',
                  });
                }}
                className="p-2 hover:bg-white/50 rounded-lg transition-colors"
              >
                <X className="w-5 h-5 text-gray-600" />
              </button>
            </div>
            <form onSubmit={editingBookingId ? handleUpdateBooking : handleCreateBooking} className="p-6 space-y-4">
              {/* {editingBookingId && bookingForm.start_time && bookingForm.end_time && (
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 p-3 rounded-xl bg-gray-50 border border-gray-200 text-sm text-gray-700">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                    <Clock className="w-4 h-4 text-gray-500 shrink-0" />
                    <span className="font-medium">Start time:</span>
                    <span>{bookingForm.start_time}</span>
                  </span>
                  <span className="text-gray-400">–</span>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                    <span className="font-medium">End time:</span>
                    <span>{bookingForm.end_time}</span>
                  </span>
                  {isEditModeAndNowWithinBooking && (
                    <span className="text-xs text-amber-700 bg-amber-50 px-2 py-0.5 rounded whitespace-nowrap">Only end time editable (in progress)</span>
                  )}
                </div>
              )} */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                    <User className="w-4 h-4" />
                    Guest Name *
                  </label>
                  <input
                    type="text"
                    value={bookingForm.guest_name}
                    onChange={(e) => setBookingForm({ ...bookingForm, guest_name: e.target.value })}
                    placeholder="Enter guest name"
                    required
                    className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                <div>
                  <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                    <Phone className="w-4 h-4" />
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    value={bookingForm.guest_phone}
                    onChange={(e) => {
                      // Only allow numeric characters
                      const numericValue = e.target.value.replace(/\D/g, '');
                      setBookingForm({ ...bookingForm, guest_phone: numericValue });
                    }}
                    placeholder="1234567890"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    required
                    className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                <div>
                  <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                    <Mail className="w-4 h-4" />
                    Email
                  </label>
                  <input
                    type="email"
                    value={bookingForm.guest_email}
                    onChange={(e) => setBookingForm({ ...bookingForm, guest_email: e.target.value })}
                    placeholder="guest@example.com"
                    className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                <div>
                  <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                    <Users className="w-4 h-4" />
                    Party Size *
                  </label>
                  <input
                    type="number"
                    value={bookingForm.party_size}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (v === '') {
                        setBookingForm({ ...bookingForm, party_size: '' });
                        return;
                      }
                      const maxSeats = selectedTable ? (Number(selectedTable.capacity) || 99) : 99;
                      const n = parseInt(v, 10);
                      if (!isNaN(n) && n >= 1 && n <= maxSeats) {
                        setBookingForm({ ...bookingForm, party_size: v });
                      }
                    }}
                    placeholder={selectedTable ? `Max ${selectedTable.capacity || 0} for this table` : 'Number of guests'}
                    min="1"
                    max={selectedTable ? (Number(selectedTable.capacity) || 99) : undefined}
                    required
                    className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                  {selectedTable && (
                    <p className="mt-1 text-xs text-gray-500">
                      Max {selectedTable.capacity} guests for this table
                    </p>
                  )}
                </div>

                <div>
                  <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                    <Calendar className="w-4 h-4" />
                    Date *
                  </label>
                  <input
                    type="date"
                    value={bookingForm.booking_date}
                    onChange={(e) => setBookingForm({ ...bookingForm, booking_date: e.target.value })}
                    min={(() => {
                      const d = new Date();
                      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                    })()}
                    required
                    className="w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                {/* Start time (left) and End time (right) on the same row */}
                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                      <Clock className="w-4 h-4" />
                      Start Time *
                    </label>
                    <select
                      value={bookingForm.start_time}
                      onChange={(e) => {
                        if (isEditModeAndNowWithinBooking) return;
                        const newStartTime = e.target.value;
                        let newEndTime = bookingForm.end_time;
                        if (newStartTime && bookingForm.end_time && bookingForm.end_time <= newStartTime) {
                          newEndTime = '';
                        }
                        setBookingForm({
                          ...bookingForm,
                          start_time: newStartTime,
                          end_time: newEndTime,
                          booking_time: newStartTime
                        });
                      }}
                      required
                      disabled={isEditModeAndNowWithinBooking}
                      className={`w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100 ${
                        isEditModeAndNowWithinBooking ? 'opacity-70 cursor-not-allowed bg-gray-50' : ''
                      }`}
                    >
                      <option value="">Select start time</option>
                      {(() => {
                        const now = new Date();
                        const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
                        const isToday = bookingForm.booking_date === todayStr;
                        const currentTimeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                        let startSlots = isToday ? timeSlots.filter(slot => slot > currentTimeStr) : timeSlots;
                        // Ensure current start_time is in the list so it displays (e.g. from filter for New Booking, or in the past for Edit)
                        if (bookingForm.start_time && !startSlots.includes(bookingForm.start_time)) {
                          startSlots = [bookingForm.start_time, ...startSlots].sort();
                        }
                        return startSlots.map((slot) => (
                          <option key={slot} value={slot}>
                            {slot}
                          </option>
                        ));
                      })()}
                    </select>
                    {isEditModeAndNowWithinBooking && (
                      <p className="mt-1 text-xs text-amber-700">Start time cannot be changed.</p>
                    )}
                  </div>
                  <div>
                    <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                      <Clock className="w-4 h-4" />
                      End Time *
                    </label>
                    <select
                      value={bookingForm.end_time}
                      onChange={(e) => setBookingForm({ ...bookingForm, end_time: e.target.value })}
                      required
                      disabled={!bookingForm.start_time}
                      className={`w-full min-h-[48px] rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100 ${
                        !bookingForm.start_time ? 'opacity-50 cursor-not-allowed bg-gray-50' : ''
                      }`}
                    >
                      <option value="">
                        {!bookingForm.start_time ? 'Select start time first' : 'Select end time'}
                      </option>
                      {bookingForm.start_time && timeSlots
                        .filter(slot => slot > bookingForm.start_time)
                        .map((slot) => (
                          <option key={slot} value={slot}>
                            {slot}
                          </option>
                        ))}
                    </select>
                    {isEditModeAndNowWithinBooking && (
                      <p className="mt-1 text-xs text-gray-500">You can extend or shorten the end time (booking in progress).</p>
                    )}
                  </div>
                </div>

                <div className="md:col-span-2">
                  <label className="flex items-center gap-2 mb-2 text-sm font-semibold text-gray-700">
                    Table
                  </label>
                  <div className="p-3 bg-white/50 rounded-xl border border-gray-200">
                    {selectedTable ? (
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700">
                          Table {selectedTable.table_no || selectedTable.table_number} ({selectedTable.capacity} seats)
                        </span>
                        {/* <button
                          type="button"
                          onClick={() => {
                            setSelectedTable(null);
                            setBookingForm({ ...bookingForm, table_id: '', table_no: '' });
                          }}
                          className="text-red-600 hover:text-red-700"
                        >
                          <X className="w-4 h-4" />
                        </button> */}
                      </div>
                    ) : (
                      <span className="text-gray-400 text-sm">Select a table from the floor plan</span>
                    )}
                  </div>
                </div>

                <div className="md:col-span-2">
                  <label className="block mb-2 text-sm font-semibold text-gray-700">
                    Special Requests
                  </label>
                  <textarea
                    value={bookingForm.special_requests}
                    onChange={(e) => setBookingForm({ ...bookingForm, special_requests: e.target.value })}
                    placeholder="Any special requests or notes..."
                    rows="3"
                    className="w-full rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>
              </div>

              <div className="flex gap-3 pt-4 border-t border-white/30">
                <Button
                  type="button"
                  onClick={() => {
                    setShowBookingForm(false);
                    setEditingBookingId(null);
                    setBookingForm({
                      guest_name: '',
                      guest_phone: '',
                      guest_email: '',
                      party_size: '',
                      booking_date: new Date().toISOString().split('T')[0],
                      booking_time: '',
                      start_time: '',
                      end_time: '',
                      table_id: '',
                      table_no: '',
                      special_requests: '',
                    });
                  }}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isLoading}
                  className="flex-1 bg-green-500 hover:bg-green-600 text-white"
                >
                  {isLoading ? (editingBookingId ? 'Updating...' : 'Creating...') : (editingBookingId ? 'Update Booking' : 'Create Booking')}
                </Button>
              </div>
            </form>
          </Card.Light>
        </div>,
        document.body
      )}
    </div>
  );
};

export default BookingBoard;